import { render, staticRenderFns } from "./GridPanelItem.vue?vue&type=template&id=5293830a&scoped=true"
import script from "./GridPanelItem.vue?vue&type=script&lang=ts"
export * from "./GridPanelItem.vue?vue&type=script&lang=ts"
import style0 from "./GridPanelItem.vue?vue&type=style&index=0&id=5293830a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5293830a",
  null
  
)

export default component.exports